import { Divider } from "antd";
import { Calendar } from "lucide-react";
import React from "react";

const Leave = ({leaveData}) => {
  return (
    <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg px-3 py-3 bg-white">
      <h3 className="text-gray-500 text-md font-medium">VACATION ({leaveData?.length || 0})</h3>
      {leaveData?.map((leave, index) => (
        <div key={leave._id} className="bg-white shadow-md rounded-lg px-3 py-3 w-full mt-2">
          <div className="flex items-center justify-center gap-2 text-gray-400 font-semibold py-3">
            <Calendar size={18} className="text-gray-400" />
            <span>{leave.title}</span>
          </div>
          <Divider className="!p-0 !m-0" />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-3">
            <div className="flex items-center justify-between text-black p-2 bg-gray-50 rounded-lg">
              <span className="text-xl font-bold">{leave.numberOfDays}</span>
              <span className="text-md">Remaining</span>
              <Calendar size={14} className="text-gray-400" />
            </div>
            <div className="flex items-center justify-between text-black text-md p-2 bg-gray-50 rounded-lg">
              <span>Entitled :</span>
              <span className="font-semibold">{leave.numberOfDays}</span>
              <Calendar size={14} className="text-gray-400" />
            </div>
            <div className="flex items-center justify-between text-black text-md p-2 bg-gray-50 rounded-lg">
              <span>Availed :</span>
              <span className="font-semibold">0</span>
              <Calendar size={14} className="text-gray-400" />
            </div>
          </div>
          <div className="mt-3 text-sm text-gray-500">
            <p><span className="font-medium">Type:</span> {leave.type}</p>
            <p><span className="font-medium">Duration:</span> {leave.leaveDuration}</p>
            <p><span className="font-medium">Description:</span> {leave.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Leave;
